import { Button } from '@/UIComponents2/Button'
import { cn } from '@/utlis/cn'

export default function DialogActionButtonsSection({
    leftButtonText,
    rightButtonText,
    isLeftButtonDisabled = false,
    isRightButtonDisabled = false,
    onLeftButtonClicked,
    onRightButtonClicked,
    fullWidthButton = true,
}: {
    leftButtonText?: React.ReactNode | null
    rightButtonText?: React.ReactNode | null
    isLeftButtonDisabled?: boolean
    isRightButtonDisabled?: boolean
    onLeftButtonClicked?: () => void
    onRightButtonClicked?: () => void
    fullWidthButton?: boolean // Controls if a single button will use the full width of the dialog
}) {
    return (
        <div className="flex justify-between items-center gap-2 pt-6 px-3 pb-1">
            {onLeftButtonClicked ? (
                <Button
                    className={cn('flex-1')}
                    variant="glow"
                    disabled={isLeftButtonDisabled}
                    onClick={onLeftButtonClicked}
                >
                    {leftButtonText || 'leftButtonText'}
                </Button>
            ) : !fullWidthButton ? (
                <div className="flex-1" />
            ) : null}

            {onRightButtonClicked ? (
                <Button
                    className={cn('flex-1')}
                    variant="primary"
                    disabled={isRightButtonDisabled}
                    onClick={onRightButtonClicked}
                >
                    {rightButtonText || 'rightButtonText'}
                </Button>
            ) : !fullWidthButton ? (
                <div className="flex-1" />
            ) : null}
        </div>
    )
}
